import { QuickMenuData } from '@services/MarppleShop/renderApp/components/cells/QuickMenu/QuickMenu.ts';
import { getResizedImage70WebpUrl } from '@services/MarppleShop/shared/util/getResizedImageUrl.ts';
import {
  makePopupScreenNavigate,
  makeShopScreenNavigate,
  makeUtilScreenNavigate,
} from '@services/MarppleShop/shared/app/navigate.ts';
import { generateProductListUrl } from '@services/MarppleShop/features/ProductList/util';
import { filter, pipe, toArray } from '@fxts/core';
import { generateProductRankingUrl } from '@services/MarppleShop/renderApp/pages/ProductRanking/utils/generateProductRankingUrl.ts';
import { ImageAsset } from '@services/MarppleShop/shared/util/image-asset.ts';
import { VideoAsset } from '@services/MarppleShop/shared/util/video-asset.ts';

export class QuickMenuController {
  constructor(private readonly is_mobile: boolean) {}

  private readonly _items: Array<QuickMenuData & { predicate: () => boolean }> = [
    {
      // 핸드메이드 크리에이터
      title_pc: ET('mps2::main::quick_menus::handmade_creator'),
      title_mo: ET('mps2::main::quick_menus::handmade_creator'),
      image: getResizedImage70WebpUrl(ImageAsset.handmade_thumbnail, 300),
      mp4_src: VideoAsset.handmade,
      navigate: makeUtilScreenNavigate(`/${T.lang}/@/advance_reservation_ad`),
      href: `/${T.lang}/@/advance_reservation_ad`,
      target: '_blank',
      predicate: () => true,
    },
    {
      // 지금 막 판매된 상품
      title_pc: ET('mps2::main::quick_menus::item_sold_now'),
      title_mo: ET('mps2::main::quick_menus::item_sold_now'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/f1679864a9fadf1ac473035be1f48f8bd1e9eb3f1.png',
        300,
      ),
      navigate: makeShopScreenNavigate(generateProductListUrl({ is_realtime: true })),
      href: generateProductListUrl({ is_realtime: true }),
      target: '_self',
      predicate: () => true,
    },
    {
      // 인기 급상승 상품 랭킹
      title_pc: ET('mps2::main::quick_menus::product_ranking'),
      title_mo: ET('mps2::main::quick_menus::product_ranking'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/d8ec4b3bbb6684f13992c7392802ddb2b675971e2.png',
        300,
      ),
      navigate: makeShopScreenNavigate(generateProductRankingUrl(ET.lang, { rank_type: 'realtime' })),
      href: generateProductRankingUrl(ET.lang, { rank_type: 'realtime' }),
      target: '_self',
      predicate: () => !this.is_mobile,
    },
    {
      // 한정판 상품
      title_pc: ET('mps2::main::quick_menus::limited'),
      title_mo: ET('mps2::main::quick_menus::limited'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/fe51007ca8472806bf371cc2deec9e3c7c45d9143.png',
        300,
      ),
      navigate: makeShopScreenNavigate(generateProductListUrl({ is_limited: true })),
      href: generateProductListUrl({ is_limited: true }),
      target: '_self',
      predicate: () => true,
    },
    {
      // 온라인 팝업스토어
      title_pc: ET('mps2::main::quick_menus::online_popup_store'),
      title_mo: ET('mps2::main::quick_menus::online_popup_store'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/7cd2f4bba9fbe29448ffc7402f9a51351ed8b01f1.png',
        300,
      ),
      navigate: makePopupScreenNavigate(`/${T.lang}/@/popup-store`),
      href: `/${T.lang}/@/popup-store`,
      target: '_self',
      predicate: () => !this.is_mobile,
    },
    {
      // 상품 큐레이션
      title_pc: ET('mps2::main::quick_menus::product_curation'),
      title_mo: ET('mps2::main::quick_menus::curation'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/2625faf8b0b50534b7ce0591170d02516e0942731.png',
        300,
      ),
      navigate: makePopupScreenNavigate(`/${T.lang}/@/curations`),
      href: `/${T.lang}/@/curations`,
      target: '_self',
      predicate: () => true,
    },
    {
      // 실시간 상품 리뷰
      title_pc: ET('mps2::main::quick_menus::realtime_review'),
      title_mo: ET('mps2::main::quick_menus::realtime_review'),
      image: getResizedImage70WebpUrl(
        '//s3.marpple.co/files/u_2232571/2025/4/original/f196bbd5148ef8136605fd05ccb884ea89129b341.png',
        300,
      ),
      navigate: makeUtilScreenNavigate(`/${T.lang}/@/communities`),
      href: `/${T.lang}/@/communities`,
      target: '_self',
      predicate: () => true,
    },
  ];

  public get items(): QuickMenuData[] {
    return pipe(
      this._items,
      filter((item) => item.predicate()),
      toArray,
    );
  }
}
